import React, { useEffect } from "react";
import "./Ece_funded_project.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  ContentCard,
} from "../../widgets";
import {
  ece_dept_menu,
  ece_funded_project,
} from "../../constants/ece_dept";

import { RadialMenu } from "../../components";

import { FaMicrochip } from "react-icons/fa6";

const Ece_funded_project = () => {
  useEffect(() => {
    document.title = "ACCET-ECE | Ece_funded_project";
  }, []);
  return (
    <div className="ecedept">
      <div className="ecebg">
        <div className="eceheading">
          Department of Electronics and Communication Engineering
        </div>
        <div className="ece_sub_heading">Funded Projects</div>
      </div>
      <section className="ecedark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaMicrochip} head="Menu" links={ece_dept_menu} />
        </div>
        <RadialMenu menu_links={ece_dept_menu} />

        <Underline heading="Funded Projects" />
        <div className="ece_funded_project_card_outer">
          
            {ece_funded_project.map((item) => (
              <ContentCard
                key={item.id}
                heading={item.program}                pdf={item.pdf}
              />
            ))}
        </div>

      </section>

      <Backtotop />
    </div>
  );
};

export default Ece_funded_project;
